import Component from '../../lib/component'

import { gsap } from 'gsap'
import Player from '@vimeo/player'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

// Component
export default class VideoScrollComponent extends Component {
    static selector () {
        return '.video-embed-iframe'
    }

    constructor (opts) {
        super(opts)

        const isAutoplay = this.el
            .src?.includes('autoplay')

        // If there's no video to autoplay on scroll enter, return
        if (!isAutoplay)
            return

        this.videoEl = new Player(this.el)

        this.videoEl.pause()

        gsap.to(this.el, {
            scrollTrigger: {
                trigger: this.el,
                start: 'top bottom',
                onEnter: () => {
                    this.videoEl.play()
                }
            }
        })
    }
}
